import { axiosHelper } from 'Services/AxiosHelper';
import { getApiGWTokenCookie } from 'Utils';
import { checkVposReqBodyData } from 'Config';

const command = 'mobile.MBCheckVposPayment';

const checkVposPaymentForMobile = async (params: checkVposReqBodyData): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default checkVposPaymentForMobile;
